import React from 'react';
import { Button, Dropdown, Menu, message } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../../PropertyGrid/PropertyGridUtils';
import PropertyEditor from "../../PropertyGrid/PropertyEditor";
import copy from 'copy-to-clipboard';

export default class ModelDataSourcesEditor extends PropertyEditor {

    state = {
        values: []
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, index) {
        let values = this.state.values;
        values[index] = e.target.value;
        this.props.source.value = [...values];
        this.setState({ values: values });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ values: this.props.source.value });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ values: this.props.source.value });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ values: nextProps.source.value });
    }

    add() {
        let values = this.state.values;
        values.push(this.props.source.modelGetter ? this.props.source.modelGetter() : new this.props.source.modelTemplate());

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    setDefault(index) {
        let values = this.state.values;
        let item = values[index];
        values.forEach(c => {
            if (c === item)
                return;

            c.isDefault = false;
        });

        item.isDefault = true;
        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    copyItem(index) {
        let item = this.state.values[index];
        item = item && item.toObject && item.toObject() || item;
        localStorage.__propertygrid_editor_objects__ = JSON.stringify(item);
        message.success("复制成功");
    }

    pasteItem(index) {

        let values = this.state.values;

        try {
            let json = localStorage.__propertygrid_editor_objects__;
            const isDefault = values[index].isDefault;
            values[index] = this.props.source.modelGetter ? this.props.source.modelGetter({ ...JSON.parse(json), isDefault: isDefault }) : new this.props.source.modelTemplate({ ...JSON.parse(json), isDefault: isDefault });

            this.props.source.value = [...values];
            this.setState({
                values
            })
            message.success("粘贴替换成功");
        }
        catch (err) {
            console.error(err);
            message.success("粘贴替换失败");
        }

        this.setState({});
    }

    deleteItem(index) {
        let values = this.state.values;
        values.splice(index, 1);
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    upItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index - 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    downItem(index) {
        let values = this.state.values;
        let item = values[index];
        values.splice(index, 1);
        values.splice(index + 1, 0, item);

        this.props.source.value = [...values];
        this.setState({
            values
        });
    }

    append(e) {
        this.props.propertyGrid.append(this.props.source, e);
    }

    render() {
        let values = this.state.values;


        return (
            <div>
                {values.map((v, index) => {

                    let title = v && v.toString();
                    let tip = title;
                    if (title && title.svg && title.text) {
                        title = (
                            <div className="layout-h fill w0 center" title={title.text}>
                                <SvgIconText type={title.svg} />
                                <div className="sp-left-md fill w0 text-nowrap">{title.text}</div>
                            </div>
                        );
                        tip = title.text;
                    }
                    if (v.isDefault)
                        title = <div className="layout-h center fill" title="默认数据源">{title}<SvgIconText type={"#anticon-tick-vulgar-copy"} size="sm" /></div>;

                    const menu = (
                        <Menu>
                            <Menu.Item key="default" onClick={e => this.setDefault(index)}><SvgIconText spacing='md' type='#anticon-icon_public_success' text='设为默认数据源' /></Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="up" onClick={e => this.upItem(index)}><SvgIconText spacing='md' type='#anticon-Uparrowsmall' text='上移' /></Menu.Item>
                            <Menu.Item key="down" onClick={e => this.downItem(index)}><SvgIconText spacing='md' type='#anticon-Downarrowsmall' text='下移' /></Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="copy" onClick={e => this.copyItem(index)}><SvgIconText spacing='md' type='#anticon-JSON-copy' text='复制' /></Menu.Item>
                            <Menu.Item key="paste" onClick={e => this.pasteItem(index)}><SvgIconText spacing='md' type='#anticon-GroupCopy' text='粘贴并替换（慎用）' /></Menu.Item>
                            <Menu.Divider />
                            <Menu.Item key="delete" onClick={e => this.deleteItem(index)}><SvgIconText spacing='md' type='#anticon-trash-gray1' text='移除' /></Menu.Item>
                        </Menu>
                    );

                    return <div key={index} className="layout-h center property-editor--objects-item" >
                        <Button className="hstretch fill layout-h" title={tip} onClick={e => this.append(v)} style={{ width: 0, padding: "5px 7px 5px 7px", textAlign: "left" }}>
                            <div className={"layout-h fill w0 text-nowrap " + ((!v || !v.enabled) && v.enabled !== undefined ? "deleted-text" : "")}>{title}</div>
                        </Button>

                        <Dropdown overlay={menu} trigger={['click']}>
                            <Button
                                className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                                style={{ padding: '7px 5px' }}>
                                <EllipsisOutlined type="ellipsis" />
                            </Button>
                        </Dropdown>
                        {/* <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector sp-left" onClick={e => this.deleteItem(index)} >
                            <SvgIconText type="#anticon-trash-gray1" />
                        </Button> */}
                    </div>
                })}
                <Button onClick={this.add.bind(this)} style={{ marginTop: 3 }}>添加</Button>
            </div>
        );
    }
}

PropertyGridUtils.register("datasources", (source, propertyGrid) => <ModelDataSourcesEditor source={source} propertyGrid={propertyGrid} />);
